import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import StageSelector from '../stage/StageSelector';

interface SidebarProps {
    isExpanded: boolean;
    toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isExpanded, toggleSidebar }) => {
    const location = useLocation();

    // Determine if current path is active
    const isActive = (path: string) => location.pathname === path;

    return (
        <div className="sidebar bg-light h-100" style={{ overflowX: 'hidden' }}>
            <Nav className="flex-column">
                <Nav.Item>
                    <Nav.Link
                        className="px-3 d-flex align-items-center"
                        onClick={toggleSidebar}
                        style={{ cursor: 'pointer' }}
                    >
                        {isExpanded ? (
                            <>
                                <i className="bi bi-arrow-bar-left"></i>
                            </>
                        ) : (
                            <i className="bi bi-arrow-bar-right"></i>
                        )}
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link
                        as={Link}
                        to="/dashboard"
                        active={isActive('/dashboard')}
                        className="px-3"
                        title="Dashboard"
                    >
                        <i className="bi bi-speedometer2 me-2"></i>
                        {isExpanded && <span>Dashboard</span>}
                    </Nav.Link>
                </Nav.Item>

                <hr className="my-1" />

                {/* Include the Stage Selector component only when expanded */}
                {isExpanded ? (
                    <StageSelector />
                ) : (
                    <Nav.Item>
                        <Nav.Link
                            as={Link}
                            to="/candidates"
                            active={isActive('/candidates')}
                            className="px-3"
                            title="Candidates"
                        >
                            <i className="bi bi-people me-2"></i>
                        </Nav.Link>
                    </Nav.Item>
                )}
            </Nav>
        </div>
    );
};

export default Sidebar;